<template>
<div id="block_display">

   <!-- Block Wrapper -->
   <!-- <div class="add-block-wrapper ">

      <div class="add-block-btn-wrapper" v-if="(userRole == 100 || userRole == 100000)" @click="addNewBlock">
         <span class="add-block-btn">Add Program Block</span>
      </div>

      <div class="add-block-inner blue-bckgd">

         <div v-if="isLoadingBlockData">
            <div class="loader-wrapper">
               <div class="loader">
               </div>
            </div>
         </div>

         <div v-else>
      
            <div class="block-subhead-wrapper"> -->
   <block-wrapper
      style="position:absolute"
      :isEditing="this.currActiveBlockRecid > 0 " 
      :isLoadingData="isLoadingBlockData"
      :hasChanged="hasChanged"
      :isSaving="isSavingBlock"
      :isDeleting="isDeletingBlock"
      @saveClicked="save"
      @saveAsClicked="saveAs"
      @resetClicked="reset"
      @deleteClicked="handleDelete"
      @cancelClicked="closeBlock">

      <div slot="header">
         <program-block-title
            :title="blockTitle"
         ></program-block-title>

         <div class="right-buttons">
            <button id="content-btn" :class="{active: contentDisplayed}" @click="contentDisplayed=true;">Content</button>
            <button id="schedule-btn" :class="{active: !contentDisplayed}" @click="contentDisplayed=false;">Schedule Detail</button>
         </div>
      </div>

      <div slot="subheader">
         <program-block-detail-info
            :runtime="blockRuntime"
            :creation="blockCreated"
            :expiration="blockExpDate"
         ></program-block-detail-info>
      </div>

      <div slot="content" v-show="contentDisplayed">
         <program-block-display-content>
         </program-block-display-content>
      </div>

      <div slot="schedule" v-show="!contentDisplayed">
         <program-block-display-schedule>
         </program-block-display-schedule>
      </div>

   </block-wrapper>
            <!-- </div> -->

            <!-- <div class="block-subhead-wrapper">
               <program-block-detail-info
                  :runtime="blockRuntime"
                  :creation="blockCreated"
                  :expiration="blockExpDate"
               ></program-block-detail-info>
            </div>

            <!-- Content -->
            <!-- <program-block-display-content  
               :class="{active: contentDisplayed}"
               ></program-block-display-content> -->

            <!-- Schedule -->
            <!-- <program-block-display-schedule 
               :class="{active: !contentDisplayed}"
               ></program-block-display-schedule> -->

            <!-- Action Bar -->
            <!-- <program-block-action-bar
               :isTrigger="blockIsTrigger == 1"
               :isEditing="recid > 0"
               :userRole="userRole"
               :start_date="blockStartDate"
               :end_date="blockEndDate"
               :start_time="blockStartTime"
               :end_time="blockEndTime"
               @saveClicked="save"
               @stageClicked="stageModal = true"
               @saveTriggersClicked="saveTriggersBlock"
               @revertTriggersClicked="revertTriggersBlock"
               @cancelClicked="closeBlock"
               @resetClicked="reset"
               @deleteClicked="handleDelete"
            ></program-block-action-bar> -->
         <!-- </div>
      </div>
   </div>  -->

   <!-- Stage For Approval Modal -->
      <!-- <stage-for-approval-modal
      v-if="stageModal"
      @close="closeModal"
      @stageForApproval="stageForApproval"
      :title="titleErrorParam"
      :reviewers="reviewersParam"
   ></stage-for-approval-modal> -->

   <!-- Currently Playing Block Error Modal -->
      <!-- <currently-playing-block
      v-if="playingBlock"
      @close="closeModal"
   ></currently-playing-block> -->

   <!-- Generic Error Modal -->
   <notify-modal
      v-if="notifyModal"
      :error="modalError"
      :title="blockTitle"
      :subheadText="modalSubheadText"
      :message="modalMessage"
      :list="modalList"
   ></notify-modal>

   <smart-canvas-overlay
      v-if="scOverlayOpen"
      @closeSmartCanvas="handleCloseSmartCanvas">
   </smart-canvas-overlay>

   
</div>
</template>

<script>
import BlockWrapper from '@/global/detail_display/BlockWrapper';
import BlockContent from '@/global/detail_display/BlockContent';

import ProgramBlockDisplayAssets from './content/ProgramBlockDisplayAssets';
import ProgramBlockTitle from './ProgramBlockTitle';
import ProgramBlockDetailInfo from './ProgramBlockDetailInfo';
import ProgramBlockDisplayContent from './content/ProgramBlockDisplayContent';
import ProgramBlockDisplaySchedule from './schedule_detail/ProgramBlockDisplaySchedule';
import ProgramBlockActionBar from './ProgramBlockActionBar';

import NotifyModal from '@/global/modals/NotifyModal';
import SmartCanvasOverlay from '@/global/modals/SmartCanvasOverlay';

import BaseBlockDisplay from './../block_detail/BaseBlockDisplay';
import { mapActions, mapState } from 'vuex';

export default {
   // extends: BaseBlockDisplay,
   data() {
      return {
         userRole: 0,
         recid: 0,
         workingRecid: 0,
         channelRecid: 0,
         contentDisplayed: true,
         runtime: 0,

         /*Edit Instance Modal */
         editInstRecid: '',
         editInstModal: false,
         playingBlock: false,
         
         slotToFeedSlots: {},

         resetTrigger: false,
         
         //TODO: formerly BaseBlockDisplay vars
         stageModal: false
      }
   },

   props: {
      mediaLibrary: Boolean //used to decide whether to display the add block option or not
   },

   computed: {
      ...mapState([
         'currActiveChannelRecid',
         'currActiveBlockRecid',
         'isGameBlock'
      ]),
      ...mapState('global', [
         'notifyModal',
         'modalError',
         'modalHeaderText',
         'modalSubheadText',
         'modalMessage',
         'modalList',

         'scOverlayOpen'
      ]),
      ...mapState('program_block', [
         'blockCategories',
         'blockCategories',
         'blockTitle',
         'blockColor',
         'blockCreated',
         'blockCurrStatus',
         'blockStartDate',
         'blockEndDate',
         'blockStartTime',
         'blockEndTime',
         'blockExpDate',
         'blockIsTrigger',
         'blockRuntime',
         'isLoadingBlockData',
         'blockChannels',
         'blockCategories',

         'isSavingBlock',
         'isDeletingBlock',

         'hasChanged',
         'hasSaved'
      ])
   },

   created() {      
      this.fetchBlockData(
         {
            vm: this, 
            blockRecid: this.currActiveBlockRecid, 
            channelRecid: this.currActiveChannelRecid
         }
      );
   },

   methods: {
      ...mapActions([
         'closeBlockDetail'
      ]),
      ...mapActions('program_block', [
         'fetchBlockData',
         'saveBlock',
         'saveAsBlock',
         'deleteBlock',
      ]),
      ...mapActions('global', [
         'openSmartCanvas',
         'closeSmartCanvas'
      ]),

      /*
         Get the data for the block
         Called when the block is loaded
      */
      getBlockData() {
         this.fetchBlockData(
            {
               vm: this, 
               blockRecid: this.currActiveBlockRecid, 
               channelRecid: this.currActiveChannelRecid
            }
         );
      },

      // openWorkingBlock() {
      //    let self = this;
      //    return new Promise((resolve, reject) => {
      //       if (self.recid > 0) {
      //          $.post(
      //             self.BARD_HOST + '/block/open_working',
      //             {
      //                'token'      : localStorage.getItem('token'),
      //                'blockRecid' : self.recid,
      //             }, function(data) {
      //                if (!data.error) {
      //                   // self.workingRecid = data.recid;
      //                   resolve(data.recid);
      //                } else {
      //                   self.handleFailedAPICall('/block/open_working', 'BlockDisplay', data);
      //                }
      //          }).fail((e) => {
      //             console.log('Error with /block/open_working: ' + e.responseText);
      //          }); 
      //       } else {
      //          $.post(
      //             self.BARD_HOST + '/block/open_working',
      //             {
      //                'token'      : localStorage.getItem('token')
      //             }, function(data) {
      //                if (!data.error) {
      //                   // self.workingRecid = data.recid;
      //                   // self.loadComponents = true;
      //                   resolve(data.recid);
      //                } else {
      //                   self.handleFailedAPICall('/block/open_working', 'BlockDisplay', data);
      //                }
      //          }).fail((e) => {
      //             console.log('Error with /block/open_working: ' + e.responseText);
      //          }); 
      //       }
      //    });
      // },

      /*
         Additional actions to take after saving a block. Called in
         BaseBlockDisplay's save() function after all other actions
         to save a block have been taken.
      */
      additionalSaveActions() {
         let self = this;
          $.post(
            self.BARD_HOST + '/dist/block',
            {
               'token'      : localStorage.getItem('token'),
               'channelRecid' : self.currActiveChannelRecid,
               'blockRecid'   : self.recid,
            }, function(data) {
               if (data.error) {
                  // self.handleFailedAPICall('/dist/block', 'BlockDisplay', data);
               }
            });

         $.post(
            self.BARD_HOST + '/dist/remote',
            {
               'token'      : localStorage.getItem('token'),
               'channelRecid' : self.currActiveChannelRecid,
               'blockRecid'   : self.recid,
            }, function(data) {
               if (data.error) {
                  // self.handleFailedAPICall('/dist/remote', 'BlockDisplay', data);
               }
            });
      },

      /*
         Close the modal for editing instances
       */
      closeModal() {
         this.editInstModal = false;
         this.stageModal = false;
         this.playingBlock = false;
      },

      /*
         Called when the 'Add Program Block' button is clicked.
         Sends an event that gets caught by Schedule to open a new
         block menu 
         TODO: Add dialog that triggers if unsaved changes have been made
       */
      addNewBlock() {
         this.$parent.$emit('openAddBlock', this.currActiveChannelRecid, true);
      },

      save() {
         // this.save();
         this.saveBlock({vm: this, blockRecid: this.currActiveBlockRecid, channelRecid: this.currActiveChannelRecid});
      },

      saveAs() {
         this.saveAsBlock({vm: this, blockRecid: this.currActiveBlockRecid, channelRecid: this.currActiveChannelRecid});
      },

      /*
         Save the block as triggers
      */
      saveTriggersBlock() {
         this.blockIsTrigger = 1;
         this.save();
      },

      /*
         Revert a block saved as triggers
      */
      revertTriggersBlock() {
         this.blockIsTrigger = 0;
         this.save();
      },

      reset() {
         this.fetchBlockData({vm: this, blockRecid: this.currActiveBlockRecid, channelRecid: this.currActiveChannelRecid});
      },

      /*
         Try to stage the block
       */
      tryStage(reviewers, note) {
         // let self = this;
         // return new Promise((resolve, reject) => {            
            
         //    $.post(
         //       self.BARD_HOST + '/block/stage',
         //       {
         //          'token'      : localStorage.getItem('token'),
         //          'recid'      : self.recid,
         //          'title' : self.block.c_name,
         //          'start_date' : self.block.c_start_date,
         //          'end_date' : self.block.c_end_date,
         //          'start_time' : self.block.c_start_time,
         //          'end_time' : self.block.c_end_time,
         //          'color': self.block.c_color,
         //          'exp_date': self.block.c_exp_date,
         //          'recurrence': self.block.c_recurrence,
         //          'trigger': self.blockIsTrigger ? 1 : 0,
         //          'channels': self.channels.toString(),
         //          'reviewers' : reviewers.toString(),
         //          'note' : note

         //       }, function(data) {
         //          if (!data.error) {
         //             resolve();
         //          } else {
         //             self.handleFailedAPICall('/block/stage/', 'BlockDisplay', data);
         //             reject();
         //          }
                  
         //       }
         //    ).fail((e) => {
         //       console.log('Error with /block/stage: ' + e.responseText);
         //       reject();
         //    }); 
         // });
      },

      closeBlock() {
         this.closeBlockDetail({vm: this, hasSaved: this.hasSaved, channels: this.blockChannels});
      },

      handleDelete() {
         this.deleteBlock({vm: this, blockRecid: this.currActiveBlockRecid});
      },

      handleCloseSmartCanvas() {
         this.closeSmartCanvas();
      }
   },

   watch: {
      currActiveBlockRecid() {
         this.getBlockData();
      }
   },

   components: {
      BlockWrapper,
      BlockContent,
      ProgramBlockDetailInfo,
      ProgramBlockTitle,
      ProgramBlockDisplayContent,
      ProgramBlockDisplaySchedule,
      ProgramBlockActionBar,
      ProgramBlockDisplayAssets,

      SmartCanvasOverlay,
      NotifyModal
   }
}
</script>

<style lang="scss" scoped>
#block_display {
   position: relative;
}

.inactive {
   display: none;
}

.add-block-wrapper {
   // min-width: 1400px;
   position: absolute;
   border-left: 1px solid white;
   border-right: 1px solid white;
   border-bottom: 1px solid white;
   width: 100%;
   // right: 0;
}

.add-block-btn-wrapper {
   padding: 10px 20px;
   color: white;
   border-bottom: 1px solid white;
   background: #5d6880;

   .add-block-btn {
      text-transform: uppercase;
      font-size: 14px;
      padding-left: 24px;

      background: url('../../../assets/img/instances/SVGs/bttn_add.svg') no-repeat left center transparent;
      background-size: 16px 16px;

      &:hover {
         background-image: url('../../../assets/img/instances/SVGs/bttn_add-active.svg'); 
         cursor: pointer;
      }
   }
}

.add-block-inner {
   padding: 30px 20px;
   min-height: 800px;
}

#media_picker + .add-block-wrapper {
   padding-top: 64px;
}

.block-subhead-wrapper {
   display: flex;
   margin-top: 7px;
   margin-bottom: 20px;
}

.right-buttons{
   padding: 0 1.5em .75em 1.5em;
   border-bottom: 1px solid #363b47;
   position: absolute;
   right: 0;

   button {
      margin-right: 1em;
      position: relative;
      background: transparent;
      border-radius: 0;
      border: 0;
      color: $gray-text;

      &.active {
         color: white;
      }

      &::after {
         position: absolute;
         content: '';
         margin: 0 auto;
         bottom: -.75em;
         left: 0;
         right: 0;
         width: 100%;
         height: 2px;
         background-color: transparent;
      }

      &:hover::after,
      &.active::after {
         background-color: #2797d9;
      }


   }
}

.slide-enter-active {
   -moz-transition-duration: 0.3s;
   -webkit-transition-duration: 0.3s;
   -o-transition-duration: 0.3s;
   transition-duration: 0.3s;
   -moz-transition-timing-function: ease-in;
   -webkit-transition-timing-function: ease-in;
   -o-transition-timing-function: ease-in;
   transition-timing-function: ease-in;
}

.slide-leave-active {
   -moz-transition-duration: 0.3s;
   -webkit-transition-duration: 0.3s;
   -o-transition-duration: 0.3s;
   transition-duration: 0.3s;
   -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to, .slide-leave {
   max-height: 100px;
   overflow: hidden;
}

.slide-enter, .slide-leave-to {
   overflow: hidden;
   max-height: 0;
}
</style>
